import * as React from 'react'

const SvgDownloadIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.25 9.375l-.881-.881-4.744 4.737V1.25h-1.25v11.981L4.631 8.494l-.881.881 6.25 6.25 6.25-6.25zm0 5.625v2.5H3.75V15H2.5v2.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V15h-1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgDownloadIcon
